import Phaser from "phaser";

export class HUD {
  private scoreText: Phaser.GameObjects.Text;
  private comboText: Phaser.GameObjects.Text;
  private timerText: Phaser.GameObjects.Text;
  private hitsText: Phaser.GameObjects.Text;
  private stageText: Phaser.GameObjects.Text;

  constructor(scene: Phaser.Scene) {
    const style: Phaser.Types.GameObjects.Text.TextStyle = {
      fontFamily: "monospace",
      fontSize: "18px",
      color: "#ffffff",
    };

    this.scoreText = scene.add.text(16, 12, "Score: 0", style).setDepth(200);
    this.comboText = scene.add
      .text(16, 36, "Combo: x1", style)
      .setDepth(200);
    this.stageText = scene.add
      .text(16, 60, "Stage: 1", style)
      .setDepth(200);
    this.timerText = scene.add
      .text(scene.scale.width - 16, 12, "Time: 35", {
        ...style,
        align: "right",
      })
      .setOrigin(1, 0)
      .setDepth(200);
    this.hitsText = scene.add
      .text(scene.scale.width - 16, 36, "Hits: 0/6", {
        ...style,
        align: "right",
      })
      .setOrigin(1, 0)
      .setDepth(200);
  }

  update(
    score: number,
    combo: number,
    timeRemainingSec: number,
    hits: number,
    requiredHits: number,
    stageIndex: number
  ): void {
    this.scoreText.setText(`Score: ${score}`);
    this.comboText.setText(`Combo: x${combo}`);
    this.timerText.setText(`Time: ${Math.ceil(timeRemainingSec)}`);
    this.hitsText.setText(`Hits: ${hits}/${requiredHits}`);
    this.stageText.setText(`Stage: ${stageIndex + 1}`);
  }

  destroy(): void {
    this.scoreText.destroy();
    this.comboText.destroy();
    this.timerText.destroy();
    this.hitsText.destroy();
    this.stageText.destroy();
  }
}
